import React from "react";
import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { TalkMod, WMSchedule } from "../../../../types/scheduling/weekend";

interface PrintTalkProps {
  wmschedule: WMSchedule;
}

export const PrintTalk: React.FC<PrintTalkProps> = (props) => {
  const { t } = useTranslation();

  return (
    <h5 className="d-flex align-items-center fw-bolder mb-4">
      {(props.wmschedule.talk_mod === TalkMod.TBD &&
        props.wmschedule.public_talk?.title === TalkMod.TBD &&
        t("schedules.weekend.tbd")) || (
        <>
          {!!props.wmschedule.public_talk?.number && (
            <Badge bg="secondary" className="me-2">
              {props.wmschedule.public_talk?.number}
            </Badge>
          )}
          {!!props.wmschedule.public_talk?.title && props.wmschedule.public_talk?.title}
        </>
      )}
    </h5>
  );
};
